import {
  BACKGROUND_COLOR_HEADER,
  BORDER_STYLE_PRIMARY,
} from '@/features/mold/components';
import type { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const ReportThead: FC<Props> = ({ children }) => (
  <thead
    style={{
      display: 'table-header-group',
      breakInside: 'avoid',
      backgroundColor: BACKGROUND_COLOR_HEADER,
      border: BORDER_STYLE_PRIMARY,
    }}
  >
    {children}
  </thead>
);
